export const QA_NAME_FLAT_CREATION_MODAL = 'create_flat'
